/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAssetCreateCustomMutationVariables = Types.Exact<{
  assetsParams: Array<Types.IAssetCreateCustomParams> | Types.IAssetCreateCustomParams;
  softwareEscrowId: Types.Scalars['ID']['input'];
  integrationId: Types.Scalars['ID']['input'];
}>;

export type IAssetCreateCustomMutation = {
  __typename?: 'Mutation';
  assetCreateCustom?: {
    __typename?: 'AssetCreateCustomPayload';
    success: boolean;
    errors?: Array<string> | null;
    assets?: Array<{
      __typename?: 'Asset';
      id: string;
      depositStatus: Types.DepositStatusEnum;
      depositMethod: Types.DepositMethodEnum;
      depositSource?: string | null;
      softwareEscrow:
        | { __typename?: 'SaasEscrow'; id: string; status: Types.EscrowStatusEnum }
        | { __typename?: 'SoftwareEscrow'; id: string; status: Types.EscrowStatusEnum };
    }> | null;
  } | null;
};

export const AssetCreateCustomDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'assetCreateCustom' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetsParams' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetCreateCustomParams' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetCreateCustom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assetsParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assetsParams' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'integrationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositMethod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositSource' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'softwareEscrow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAssetCreateCustomMutation, IAssetCreateCustomMutationVariables>;
